import React from "react";
import ProfileDetails from "../../views/ProfileDetails";

const ProfileDetailPage = () => {
  return <ProfileDetails />;
};

export default ProfileDetailPage;
